module.exports = __webpack_public_path__ + "assets/webgl/360_vignes_L0.c314f5d8.jpg";